import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SoleContact } from 'taxtank-core';

@Component({
  selector: 'app-sole-contact-form-dialog',
  templateUrl: './sole-contact-form-dialog.component.html',
  styleUrls: ['./sole-contact-form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleContactFormDialogComponent {
  public dialogRef = inject(MatDialogRef<SoleContactFormDialogComponent>);
  public soleContact = inject<SoleContact>(MAT_DIALOG_DATA);
}
